var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMenu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 32 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32 1.5C32 2.32843 31.3284 3 30.5 3H1.5C0.671572 3 0 2.32843 0 1.5C0 0.671573 0.671572 0 1.5 0H30.5C31.3284 0 32 0.671573 32 1.5ZM32 10.5C32 11.3284 31.3284 12 30.5 12H1.5C0.671572 12 0 11.3284 0 10.5C0 9.67157 0.671572 9 1.5 9H30.5C31.3284 9 32 9.67157 32 10.5ZM30.5 21C31.3284 21 32 20.3284 32 19.5C32 18.6716 31.3284 18 30.5 18H1.5C0.671572 18 0 18.6716 0 19.5C0 20.3284 0.671572 21 1.5 21H30.5Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenu);
export default __webpack_public_path__ + "static/media/menu.2bc90fb4908e52d461c6d8ea299f7b0b.svg";
export { ForwardRef as ReactComponent };